export const config = {
  apiUrl: process.env.REACT_APP_API_URL ?? '//localhost:4000',
};
